import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const BarChart = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M15 14H16.5C16.75 14 17 13.75 17 13.5V8.25C17 8 16.75 7.75 16.5 7.75H15C14.75 7.75 14.5 8 14.5 8.25V13.5C14.5 13.75 14.75 14 15 14V14ZM18.75 14H20.25C20.5 14 20.75 13.75 20.75 13.5V4.5C20.75 4.25 20.5 4 20.25 4H18.75C18.5 4 18.25 4.25 18.25 4.5V13.5C18.25 13.75 18.5 14 18.75 14ZM7.5 14H9C9.25 14 9.5 13.75 9.5 13.5V10.75C9.5 10.5 9.25 10.25 9 10.25H7.5C7.25 10.25 7 10.5 7 10.75V13.5C7 13.75 7.25 14 7.5 14ZM11.25 14H12.75C13 14 13.25 13.75 13.25 13.5V5.75C13.25 5.5 13 5.25 12.75 5.25H11.25C11 5.25 10.75 5.5 10.75 5.75V13.5C10.75 13.75 11 14 11.25 14V14ZM21.375 16.5H4.5V4.625C4.5 4.27969 4.22031 4 3.875 4H2.625C2.27969 4 2 4.27969 2 4.625V17.75C2 18.4402 2.55977 19 3.25 19H21.375C21.7203 19 22 18.7203 22 18.375V17.125C22 16.7797 21.7203 16.5 21.375 16.5Z" />
  </SvgIcon>
));

BarChart.displayName = 'BarChart';

export default BarChart;
